<template>
    <el-dialog
        class="nopush-dialog-container"
        :visible.sync="dialogShow"
        width="460px"
        :close-on-click-modal="false"
        :show-close="false"
        height="600px">
        <div class="nopush-dialog-content">
            <el-form
                ref="rectificationForm"
                :label-position="'top'"
                :rules="rules"
                :model="rectificationForm"
                label-width="80px">
                <el-form-item v-if="dialogType === 'noNeedEdit'" label="无需推送原因" prop="reason">
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入无需推送原因"
                        :show-word-limit="true"
                        maxlength="250"
                        v-model="rectificationForm.reason"></el-input>
                </el-form-item>
                <div v-if="tipText" label="" >
                   <span class="font-red">{{ tipText }}</span>
                </div>
            </el-form>
    
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button v-if="dialogType === 'noNeedEdit'" :loading="submitLoading" type="primary" @click="onConfirm">
                确定
            </el-button>
            <el-button :loading="submitLoading" @click="onClose">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { updateSupplierLegalPersonPerformanceStatus } from '../../../../api/performManage.js'
export default {
    props: {},
    data() {
        return {
            dialogShow: false,
            submitLoading: false,
            rectificationForm: { reason: '', mipName: '', mipCode: '' },
            tipText:'',
            queryData: {},
            rules: {
                reason: [{ required: true, message: '请输入无需推送原因', trigger: 'blur' }],
                mipName: [{ required: true, message: '点击选择跟进人', trigger: 'change' }],
            },
            showPerDialog: false,
        }
    },
    mounted() {},
    computed: {
        dialogType() {
            return this.queryData.type
        },
    },
    methods: {
        open(params) {
            this.queryData = params
            this.dialogShow = true
            this.rectificationForm.reason=''
            if(params.performLevel==='1'){
                this.tipText = '注意：分公司层级绩效操作无需推送，对应的分公司（内外部）、经营中心、经营中心（内外部）、服务平台、服务平台（内外部）层级“待推送供应商”状态绩效，将自动变更为“无需推送”状态。'
            }
            else if(params.performLevel==='2'){
                this.tipText = '注意：服务平台层级绩效操作无需推送，对应的服务平台（内外部）层级“待推送供应商”状态绩效，将自动变更为“无需推送”状态。'
            }
            else if(params.performLevel==='3'){
                this.tipText=''
            }
            else if(params.performLevel==='5'){
                //分公司（内外部）
                this.tipText = '注意：分公司（内外部）层级绩效操作无需推送，对应的经营中心（内外部）、服务平台（内外部）层级“待推送供应商”状态绩效，将自动变更为“无需推送”状态。'
            }
            else if(params.performLevel==='6'){
                //经营中心
                this.tipText = '注意：经营中心层级绩效操作无需推送，对应的经营中心（内外部）、服务平台、服务平台（内外部）层级“待推送供应商”状态绩效，将自动变更为“无需推送”状态。'
            }
            else if(params.performLevel==='7'){
                //经营中心（内外部）
                this.tipText = '注意：经营中心（内外部）层级绩效操作无需推送，对应的服务平台（内外部）层级“待推送供应商”状态绩效，将自动变更为“无需推送”状态。'
            }
            this.$nextTick(() => {
                this.$refs['rectificationForm'].clearValidate()
            })
        },

        onClose() {
            this.dialogShow = false
        },
        //无需推送
        onConfirm() {
            this.$refs['rectificationForm'].validate(valid => {
                if (valid) {
                    let idsList = []
                    for (const item of this.queryData.selectList) {
                        idsList.push(item.id)
                    }
                    let params = {
                        ids: idsList,
                        operativeFunctionReason: this.rectificationForm.reason,
                        performanceDimension: this.queryData.performLevel,
                        operativeFunction: '17', //17： 无需推送供应商
                    }
                    this.submitLoading = true
                    updateSupplierLegalPersonPerformanceStatus(params)
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success(res.msg)
                                this.$emit('refresh')
                            }
                        })
                        .finally(() => {
                            this.submitLoading = false
                            this.onClose()
                        })
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
    display: none;
}

.nopush-dialog-container {
    .required {
        color: red;
    }
    
    .font-red {
        display: inline-block;
        color: red;
        line-height: 1.5;
    }
}
</style>
